import { Component } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'hs-bulk-dialog-sort-warning-modal',
  templateUrl: './bulk-dialog-sort-warning-modal.component.html',
})
export class BulkDialogSortWarningModalComponent {
  constructor(readonly activeModal: NgbActiveModal) {}
}
